import APIClient from '../../../common/APIClient';
import { toggleShowAlert, displayError, SUCCESS_ALERT, ERROR_ALERT } from '../commonActions';
import { TEAM_LEADER } from '../../actions/users/usersActions'
import { Cache } from 'aws-amplify';

const FETCH_APPROVALS = 'FETCH_APPROVALS';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchApprovals = () => {
  return (dispatch) => {
    const userId = Cache.getItem('userId');
    client().get(
      'timesheet/for-approval-timesheet', {
        params: {
          user_id: userId
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        const data = result.data;
        let approvals = [];

        data.filter(item => {
          const roleId = Cache.getItem('roleId');
          const userId = Cache.getItem('userId');

          if (roleId === TEAM_LEADER) {
            if (typeof(item.requestor_details) !== "undefined") {
              const requestor = item.requestor_details;
              if (requestor && typeof(requestor.supervisor_id) !== "undefined") {
                if (userId === requestor.supervisor_id) {
                  return item;
                }
              }
            }
            return false;
          }
          else {
            return item;
          }
        }).forEach(approval => {
          approvals.push(approval);
        })

        if (approvals.length === 0) {
          approvals = null;
        } else {
          approvals = approvals.reverse();
        }

        dispatch({type: FETCH_APPROVALS, approvals});
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const approveTimesheet = (timesheetId, successCallback = null) => {
  return (dispatch, getState) => {
    const user = getState().users.currentUser;
    if (Object.keys(user).length > 0) {
      const userId = user.id;

      const timesheet = getState().timesheets.timesheet;
      if ( !timesheetId && Object.keys(timesheet).length > 0) {
        timesheetId = timesheet.timesheet_id;
      }
      
      client().post(
        'timesheet-approval/approve', {
          timesheet_id: timesheetId, 
          approver_id: userId 
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          if (successCallback) {
            successCallback();
          }
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Timesheet has been successfully approved."));
        }
      }).catch(error => {
        dispatch(displayError(error))
      })
    }
  }
}

export const rejectTimesheet = (timesheetId, successCallback = null) => {
  return (dispatch, getState) => {
    const user = getState().users.currentUser;
    if (Object.keys(user).length > 0) {
      
      const timesheet = getState().timesheets.timesheet;
      if (!timesheetId && Object.keys(timesheet).length > 0) {
        timesheetId = timesheet.timesheet_id;
      }

      let isRemarksBlank = true;

      if (typeof(timesheet.remarks) !== "undefined") {
        const remarks = timesheet.remarks;
        if (remarks) {

          isRemarksBlank = false;
          
          client().post(
            'timesheet-approval/reject', {
              timesheet_id: timesheetId, 
              remarks
            }
          ).then(json => {
            const result = json.data;
            if (result) {
              if (successCallback) {
                successCallback();
              }
              dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Timesheet has been rejected."));
            }
          }).catch(error => {
            dispatch(displayError(error))
          })
        }
      }

      if (isRemarksBlank) {
        dispatch(toggleShowAlert(true, ERROR_ALERT, "Please enter remarks."));
      }
    }
  }
}

export const approveAllTimesheets = (timesheetIds, successCallback = null) => {
  return (dispatch, getState) => {
    const user = getState().users.currentUser;
    if (timesheetIds && Object.keys(user).length > 0) {
      const userId = user.id;
      
      client().post(
        'timesheet-approval/batch/approve', {
          timesheet_ids: timesheetIds, 
          approver_id: userId 
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Timesheets hava all been successfully approved."));

          if (successCallback) {
            successCallback();
          }
        }
      }).catch(error => {
        dispatch(displayError(error))
      })
    }
  }
}